$(function () {
    var search_icon = $('.header_search_top a');
    function removeClassTopNav(classname) {
        classname.removeClass('header_active search_transorm_dark_bg');
    }
    search_icon.on('click', function (event) {
        if($('.header_burger').attr('aria-expanded') == "true") {
            $('.header_burger').click();
        }
        if($('.header_quicklink').attr('aria-expanded') == "true") {
            $('.quicklink_section_mv').removeClass('open');
        }
        if ($('.header_search_top').hasClass('active')) {
            $('.header_global_search_form').stop().fadeOut();
           
        } else {
            $('.header_global_search_form').stop().fadeIn();
        }          
        event.stopPropagation();
        if ($('.header_search_top').hasClass('active')) {
            search_icon.parent().removeClass('active');
            $('.header_global_search_form .gsc-input input[type="text"].gsc-input').blur();
            removeClassTopNav($('.global_header .logo_line'));
            removeClassTopNav($('.home_header_line'));
            if($('.sectionfixed')[0]) {
               removeClassTopNav($('.head_inner_second_line .logo_line'));
            }
        } else {
            search_icon.parent().addClass('active');
            $('.header_global_search_form input[type="text"].gsc-input').focus();
            $('.global_header .logo_line').addClass('header_active search_transorm_dark_bg');
            $('.home_header_line').addClass('header_active');
            if($('.sectionfixed')[0]) {
                $('.head_inner_second_line .logo_line').addClass('header_active search_transorm_dark_bg');
            }
        }
    });
    $('span.header_global_search_insert, span.header_global_search_insert *').click(function (event) {
        return false;
    });
    $('*:not(.header_search_top, .header_search_top *, span.header_global_search_insert, .nav_top_link, span.header_global_search_insert *)').on('click',function (e) {
        if(search_icon.parent().hasClass('active')) {
            search_icon.parent().removeClass('active');
            removeClassTopNav($('.global_header .logo_line'));
            removeClassTopNav($('.home_header_line'));
            if($('.sectionfixed')[0]) {
                removeClassTopNav($('.head_inner_second_line .logo_line'));
            }
            $('.header_global_search_form').stop().fadeOut();
        }
    });
    $('.header_search_top, .header_search_top img').keypress(function (e) {
        if (e.keyCode == 13) {
            $('.header_search_icon_black').click();
        }
    });
});